/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FinancialIndicatorValueBase'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./FinancialIndicatorValueBase'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialIndicatorDataReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.FinancialIndicatorValueBase);
  }
}(this, function(ApiClient, FinancialIndicatorValueBase) {
  'use strict';




  /**
   * The FinancialIndicatorDataReport model module.
   * @module model/FinancialIndicatorDataReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>FinancialIndicatorDataReport</code>.
   * @alias module:model/FinancialIndicatorDataReport
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>FinancialIndicatorDataReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FinancialIndicatorDataReport} obj Optional instance to populate.
   * @return {module:model/FinancialIndicatorDataReport} The populated <code>FinancialIndicatorDataReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'String');
      }
      if (data.hasOwnProperty('CompanyID')) {
        obj['CompanyID'] = ApiClient.convertToType(data['CompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketScopeTypeID')) {
        obj['MarketScopeTypeID'] = ApiClient.convertToType(data['MarketScopeTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('BusinessID')) {
        obj['BusinessID'] = ApiClient.convertToType(data['BusinessID'], 'String');
      }
      if (data.hasOwnProperty('StartYear')) {
        obj['StartYear'] = ApiClient.convertToType(data['StartYear'], 'Integer');
      }
      if (data.hasOwnProperty('EndYear')) {
        obj['EndYear'] = ApiClient.convertToType(data['EndYear'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Data')) {
        obj['Data'] = ApiClient.convertToType(data['Data'], [FinancialIndicatorValueBase]);
      }
    }
    return obj;
  }

  /**
   * @member {String} ID
   * @default ''
   */
  exports.prototype['ID'] = '';
  /**
   * @member {Integer} CompanyID
   * @default 0
   */
  exports.prototype['CompanyID'] = 0;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} MarketScopeTypeID
   * @default 0
   */
  exports.prototype['MarketScopeTypeID'] = 0;
  /**
   * @member {String} BusinessID
   * @default ''
   */
  exports.prototype['BusinessID'] = '';
  /**
   * @member {Integer} StartYear
   */
  exports.prototype['StartYear'] = undefined;
  /**
   * @member {Integer} EndYear
   */
  exports.prototype['EndYear'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Array.<module:model/FinancialIndicatorValueBase>} Data
   */
  exports.prototype['Data'] = undefined;



  return exports;
}));


